import { render, staticRenderFns } from "./SuspendedCeiling.vue?vue&type=template&id=573af5d3&"
import script from "./SuspendedCeiling.vue?vue&type=script&lang=js&"
export * from "./SuspendedCeiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports